import confetti from 'canvas-confetti';
import { FIREWORKS_LATENCY, SHOOL_LATENCY } from '../constants';

export const fireworks = () => {
  const canvas = document.getElementById('global-canvas');
  canvas.confetti =
    canvas.confetti ||
    confetti.create(canvas, {
      resize: true,
    });

  const end = Date.now() + FIREWORKS_LATENCY;
  const interval = setInterval(function() {
    if (Date.now() > end) {
      return clearInterval(interval);
    }
    canvas.confetti({
      startVelocity: 30,
      spread: 360,
      particleCount: 80,
      ticks: 60,
      shapes: ['square'],
      origin: {
        x: Math.random(),
        // since they fall down, start a bit higher than random
        y: Math.random() - 0.2,
      },
    });
  }, 400);
};

export const shoolPride = () => {
  const canvas = document.getElementById('global-canvas');
  canvas.confetti =
    canvas.confetti ||
    confetti.create(canvas, {
      resize: true,
    });

  var end = Date.now() + SHOOL_LATENCY;
  // go Buckeyes!
  var colors = ['#0000ff', '#ff0000', '#ffff00'];
  (function frame() {
    canvas.confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: {
        x: 0,
      },
      colors,
    });
    canvas.confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: {
        x: 1,
      },
      colors,
    });
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
};
